import { createPinia } from 'pinia';

// Create pinia instance
const pinia = createPinia();

// Note: Auth persistence is handled manually in the auth store (stores/auth.js)
// to avoid circular dependencies with the API service layer.
// Other stores can use a persistence plugin if needed.

export default pinia;
